module.exports = __webpack_public_path__ + "static/media/logo.aeaff385.png";